import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client'
import { queryClient, queryClientPersister } from '@/queries/config'

export function Provider({ children }: { children: React.ReactNode }) {
  return (
    <PersistQueryClientProvider
      client={queryClient}
      persistOptions={{
        persister: queryClientPersister,
        maxAge: 1000 * 60 * 60 * 12,
        buster: 'v1',
      }}
      onSuccess={() => {
        queryClient.resumePausedMutations().then(() => {
          queryClient.invalidateQueries()
        })
      }}
    >
      {children}
    </PersistQueryClientProvider>
  )
}
